// Проверяет загруженный файл.

import errorMessage from "../domain/error-message";

const settings = window.DA.settings;

const hasValidSize = function (file) {
    return file.size <= settings.TRY_DOCUMENT_MAX_SIZE;
};

const hasValidType = function (file) {
    if (file.type) {
        return settings.TRY_DOCUMENT_CONTENT_TYPES.includes(file.type);
    }
    // can not recognize type, so make it valid to send document for server side validation
    return true;
};

const getErrors = function (file) {
    var errors = [];
    if (!hasValidSize(file)) {
        errors.push("FILE_TOO_LARGE");
    }
    if (!hasValidType(file)) {
        errors.push("FILE_WRONG_TYPE");
    }
    return errors;
};

const getTextErrors = function (file) {
    const errors = getErrors(file);

    const textErrors = [];
    for (let error of errors) {
        textErrors.push(errorMessage[error]);
    }
    return textErrors;
};

export default {
    getTextErrors: getTextErrors,
    getErrors: getErrors,
    hasValidSize: hasValidSize,
    hasValidType: hasValidType,
};
